const RTL_LOCALES: ReadonlySet<string> = new Set(["ar", "he"]);

export const RTLDirector = {
  /** Returns true if the base locale is RTL */
  isRTL(baseLocale: string): boolean {
    return RTL_LOCALES.has(baseLocale);
  },

  /**
   * Apply dir attribute to the document root and set input-level
   * dir="ltr" on numeric inputs to keep card numbers LTR.
   */
  apply(container: HTMLElement, isRTL: boolean): void {
    const doc = container.ownerDocument;
    doc.documentElement.setAttribute("dir", isRTL ? "rtl" : "ltr");

    // Numeric inputs always stay LTR
    const inputs = container.querySelectorAll<HTMLInputElement>("input[type='tel']");
    for (const input of inputs) {
      input.setAttribute("dir", "ltr");
    }
  },
};
